import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  EndorsementPaymentDetailInterface,
  EndorsementPaymentFormInterface
} from "src/app/dashboard/endorsement-payment/endorsement.interface";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CheckerInterface } from "src/app/share/interface/motor.interface";
import { Observable } from "rxjs";
import { SalesCampaignDto } from "src/app/share/interface/response.interface";

@Injectable({
  providedIn: "root"
})
export class VoucherService {
  private basePath: string = `${environment.url}/api/Motor/`;

  constructor(private http: HttpClient) {}

  getVoucherListByVehicleNo(
    vehicleNo: string,
    totalAmount: number,
    voucherCodes?: string[]
  ) {
    let params = new HttpParams().set("totalAmount", totalAmount.toString());

    if (voucherCodes && voucherCodes.length > 0) {
      params = params.set("voucherCodes", voucherCodes.join(","));
    }

    return this.http.get(
      `${this.basePath}GetVoucherByVehicleNo/${vehicleNo}`,
      { params }
    );
  }

  getReferralCode(code: string, priceAmount: number, vehicleNo: string) {
    let params = new HttpParams().set("priceAmount", priceAmount.toString()).set("vehicleNo", vehicleNo);;
    return this.http.get(`${this.basePath}GetReferralCode/${code}`, {params});
  }

  campaignOnGoing() {
    return this.http.get<boolean>(`${this.basePath}GetOnGoingCampaign`);
  }


  checkPromoOrReferral(code: string): Observable<CheckerInterface> {
    return this.http.get<CheckerInterface>(
      `${this.basePath}CheckPromoOrReferral?code=` + code
    );
  }
}
